var LZString = require('lz-string');
var ImageCompressor = require('image-compressor.js');
 
export default class ExerciseNewPostController  {    
    constructor($scope, $rootScope, $routeParams, userService, authenticationService, $mdToast, globalConstants, exerciseService) {
        this.$scope = $scope;
        this.$scope.sending = false;
        this.exerciseService = exerciseService;
        this.exerciseId = $scope.exerciseId;
        this.exercisePaused = $scope.exercisePaused;
        this.$rootScope = $rootScope;
        this.$routeParams = $routeParams;
        this.exerciseHubService = $scope.exerciseHubService;
        this.round = Math.round;
        this.$mdToast = $mdToast;
        this.globalConstants = globalConstants;
        this.textBoxHeight = { height: "140px" };
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.userService.getCurrent().then(resp => {
            this.account = resp.data;
        });
        this.resetTweet();
        this.exerciseService.get($routeParams.id).then(resp => {
            this.exerciseMessageCharacters = resp.data.exerciseMessageCharacters;
        });
    }

    cancelImage() {
        this.$scope.message.imageUpload = null;
        this.$scope.imageUrl = undefined;
        this.$scope.message.image = null
    }

    resize($event) {
        this.dynamicTextBoxHeight = { height: $event.target.scrollHeight + "px"};
    }

    send(newMessageForm) {
        if(!newMessageForm.$valid)
            return;
        
        var message = this.$scope.message;
        message.likes = [];
        message.initialLikes = message.favourites;
        message.type = this.$scope.activeTab;

        message["userDetail"] = {
            userId: this.account.id,
            userName: this.account.name,
            icon: this.account.icon
        };

        if(this.$scope.avatar != null)
        {
            message["avatar"] = this.$scope.avatar;
        }

        message["createdDate"] = new Date(Date.now());
        
        this.$scope.sending = true;

        new Promise((resolve) => {
            setTimeout(resolve, 500);
          }).then(()=>{ 

            this.exerciseHubService.sendMessage(message).then(()=> {
                this.$scope.$apply(() => {
                    this.resetTweet();
                    this.dynamicTextBoxHeight = { height: "140px" };
                    this.textBoxHeight = { height: "140px" };
            
                    this.$mdToast.show(
                        this.$mdToast.simple()
                            .textContent('Post submitted')
                            .position('top left right' )
                            .hideDelay(3000) 
                            .theme('success-toast')
                        );
                    document.getElementById("message").blur();
                    window.getSelection().removeAllRanges();
                });
            })
            .catch(err => {
                window.alert("Unable to send post. Please check your internet connection and try again.");
            }).finally(()=>{
                this.$scope.$apply(()=>{
                    this.$scope.sending = false;
                }); 
            });

          });
    }

    onMessageImageUpload() {
        var that = this;
        new ImageCompressor.default(this.$scope.image, {
            quality: 0.5,
            maxWidth: 480,
            
            success: (result) => {
                var reader  = new FileReader();
                reader.addEventListener("load", function () {
                    that.$scope.$apply(() => {
                        that.$scope.message.image = reader.result;
                        that.$scope.imageUrl = reader.result;
                    });
                }, false);

                if (that.$scope.image) {
                    reader.readAsDataURL(result);
                }
            }
        });  
    }

    resetTweet() {
        this.$scope.message.tweet = "";
        this.$scope.message.shares = [],
        this.$scope.message.likes = [],
        this.$scope.message.initialLikes = 0 ,
        this.$scope.message.exerciseId = this.exerciseId;
        this.$scope.message.retweetPost = null;
        this.$scope.message.inReplyToId = null;
        this.$scope.message.replies = [];
        this.$scope.message.image = "";
        this.$scope.imageUrl = "";
        this.$scope.message.delayInMinutes = null;
        this.$scope.message.favourites = null;
        this.$scope.message.type = null;
    }
}


// WEBPACK FOOTER //
// ./src/js/components/exercise/exercise.newpost.controller.js